import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #IMAGE-GALLERY
\*------------------------------------ */
/**
 * 1) Image gallery
 */
.cat-c-image-gallery {
  display: flex;
  width: 100%;
  height: 100%;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery {
  --cat-c-image-gallery__flex-basis: auto;
  flex-direction: row;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery.cat-c-image-gallery--bottom {
  flex-direction: column-reverse;
  align-items: center;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery.cat-c-image-gallery--bottom ::slotted(cat-image-gallery-thumbnail) {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  margin-block-start: calc(var(--size-base-unit) * 2);
  margin-inline: auto;
  max-width: 100%;
  --cat-c-image-gallery-thumbnail-overflow: visible;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery.cat-c-image-gallery--sm ::slotted(cat-image-gallery-thumbnail) {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  margin-block-start: calc(var(--size-base-unit) * 2);
  margin-inline: auto;
  max-width: 100%;
  --cat-c-image-gallery-thumbnail-overflow: visible;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery.cat-c-image-gallery--right {
  flex-direction: row-reverse;
}
.cat-c-image-gallery.cat-c-image-gallery--custom-gallery.cat-c-image-gallery--sm {
  flex-direction: column-reverse;
  align-items: normal;
}

/**
 * Image container for large display image
 */
.cat-c-image-gallery__img-container {
  margin-inline-start: var(--cat-space-medium);
  flex: 1;
  height: var(--cat-c-image-gallery__img-container-height, auto);
  width: var(--cat-c-image-gallery__img-container-width, 100%);
  display: flex;
  position: relative;
  flex-direction: var(--cat-c-image-gallery__img-container-flex-direction, column);
  /**
   * Remove margin on display image
   */
  /**
   * Small variant styling for image container
   */
  /**
   * Add margin on the display image on the right aligned grid
   */
  /**
  * Style for thumbnailtext, which can be customize if need using variable token
  */
}
.cat-c-image-gallery--bottom .cat-c-image-gallery__img-container {
  margin-inline-start: 0;
  width: 100%;
  margin-block-end: var(--cat-c-image-gallery--bottom-padding-bottom, var(--cat-space-2x-large));
}
.cat-c-image-gallery--sm .cat-c-image-gallery__img-container {
  margin-inline: 0;
  margin-block-end: var(--cat-space-3x-large);
}
@media all and (min-width: 48rem) {
  .cat-c-image-gallery--right .cat-c-image-gallery__img-container {
    margin-inline-end: var(--cat-space-medium);
  }
}
.cat-c-image-gallery__img-container .cat-c-image-gallery__thumbnail-text-container {
  display: var(--cat-c-image-gallery__thumbnail-text-container, flex);
}
.cat-c-image-gallery__img-container .cat-c-image-gallery__thumbnail-text-container .cat-c-image-gallery__thumbnail-heading {
  position: var(--cat-c-image-gallery__thumbnail-heading-position, absolute);
  inset-inline-start: var(--cat-c-image-gallery__thumbnail-heading-left, 50%);
  transform: var(--cat-c-image-gallery__thumbnail-heading-transform, translateX(-50%));
  max-width: var(--cat-c-image-gallery__thumbnail-heading-max-width, calc(100% - var(--size-base-unit) * 4));
  padding: var(--cat-c-image-gallery__thumbnail-heading-padding, var(--cat-space-3x-small));
  inset-block-start: var(--cat-c-image-gallery__thumbnail-heading-top, 100%);
  background: var(--cat-c-image-gallery__thumbnail-heading-background, transparent);
  color: var(--cat-c-image-gallery__thumbnail-heading-color, currentColor);
  margin: var(--cat-c-image-gallery__thumbnail-heading-margin, auto);
  font-size: var(--cat-c-image-gallery__thumbnail-heading-font-size, inherit);
  font-weight: var(--cat-c-image-gallery__thumbnail-heading-font-weight, inherit);
}

/**
 * Flex grid items
 */
.cat-c-image-gallery__grid {
  display: flex;
  flex-direction: column;
  /**
   * Bottom gallery 
   */
}
.cat-c-image-gallery--bottom .cat-c-image-gallery__grid {
  flex-direction: row;
  overflow-x: auto;
  margin-block-start: var(--cat-space-medium);
  margin-inline: auto;
  width: auto;
  max-width: 100%;
  --cat-c-image-gallery-thumbnail-overflow: visible;
}

/**
 * Styling for display image element
 */
.cat-c-image-gallery__img {
  display: flex;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.cat-c-image-gallery--cover .cat-c-image-gallery__img {
  object-fit: cover;
}
.cat-c-image-gallery--fill .cat-c-image-gallery__img {
  object-fit: fill;
}
.cat-c-image-gallery--none .cat-c-image-gallery__img {
  object-fit: none;
}

/**
 * class added for iframe -video gallery
 */
.cat-c-image-gallery__iframe {
  border: none;
  width: 100%;
  height: var(--cat-c-image-gallery__iframe-height, 100%);
  aspect-ratio: var(--cat-c-image-gallery__iframe-aspect-ratio, 2);
}

/**
 * Container for icon container on small variant
 */
.cat-c-image-gallery__icon-container {
  display: flex;
  overflow-x: auto;
  max-width: 100%;
  margin: auto;
  margin-block-start: var(--cat-space-3x-large);
  padding: var(--cat-space-3x-small);
}
.cat-c-image-gallery__icon-container .cat-c-image-gallery__icon-wrapper {
  display: flex;
}

/**
 * wrapper for individual icon in small variant
 */
.cat-c-image-gallery__icon-link_wrapper {
  display: flex;
  /**
   * Focus state on icon
   */
}
.cat-c-image-gallery__icon-link_wrapper:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Icon link
 */
.cat-c-image-gallery__icon-link {
  width: calc(var(--size-base-unit) * 6);
  height: calc(var(--size-base-unit) * 6);
  border-radius: var(--cat-theme-border-radius);
  position: relative;
  margin: var(--cat-space-medium);
  scroll-margin: var(--cat-space-medium);
  /**
   * dot style
   */
  /**
   * Active state on icon
   */
  /**
   * Hover/active state on icon
   */
}
.cat-c-image-gallery__icon-link:after {
  content: "";
  position: absolute;
  width: calc(var(--size-base-unit) * 2);
  height: calc(var(--size-base-unit) * 2);
  border-radius: 100%;
  background-color: var(--cat-theme-color-background-strong);
  inset-block-start: var(--cat-space-medium);
  inset-inline-start: var(--cat-space-medium);
}
.cat-c-image-gallery__icon-link.cat-is-active:after {
  background-color: var(--cat-theme-color-background-xstrong);
}
.cat-c-image-gallery__icon-link:active:after, .cat-c-image-gallery__icon-link:hover:after {
  background-color: var(--cat-theme-color-background-xstrong);
}

/**
   * Bottom aligned gallery
   */
.cat-c-image-gallery--bottom {
  flex-direction: column-reverse;
}

/**
   * Small variant flex direction
   */
.cat-c-image-gallery--sm {
  flex-direction: column-reverse;
  align-items: center;
}

/**
    * Right positioned grid flex direction
    */
.cat-c-image-gallery--right {
  flex-direction: row-reverse;
  /**
   * Ensures right positioned grid + mobile variant
   * is positioned correctly on small screens
   */
}
.cat-c-image-gallery--right.cat-c-image-gallery--sm {
  flex-direction: column-reverse;
}

::slotted(cat-image-gallery-thumbnail) {
  display: flex;
  flex-direction: column;
}

::slotted(cat-image-gallery-item[isactive]) {
  flex-basis: 100%;
}
`;
       